export default __webpack_public_path__ + "static/media/Redo.3e316372.svg";